/**
 * 函数防抖
 * @param fn
 * @param wait
 * @returns {Function}
 */
export function debounce(fn, wait) {
  let timeout = null;
  return function () {
    if (timeout !== null) clearTimeout(timeout);
    timeout = setTimeout(fn, wait);
  };
}

export const userRegister = {
  title: '用户注册协议',
  paragraph: [{
    subHeaderText: '尊敬的用户，您好！在此特别提醒您认真阅读、充分理解本《用户注册协议》（下称《协议》），包括免除或者限制吉日历服务平台（以下简称“平台”）责任的免责条款及对您的权利限制条款。请您审慎阅读并选择接受或不接受本《协议》。除非您接受本《协议》所有条款，否则您无权注册、登录或使用“吉日历”所提供的相关服务。您安装并使用平台提供的服务即表示接受本协议的全部条款，以及本协议有效期内各项条款的更新。本协议适用于所有吉日历自主提供的服务，包括本协议期限内的用户所使用的各项服务和软件的升级和更新。您的使用行为将视为对本《协议》的接受，并同意接受本《协议》各项条款的约束。本协议系由与所有使用吉日历软件的主体（包括但不限于个人、团队等）（以下简称“用户”、“您”）对吉日历软件服务的使用及相关服务所订立的有效合约。本《协议》包含服务平台与您之间关于“吉日历”服务相关方面的权利义务。',
    subTitle: '引言',
  }, {
    subTitle: '一、 服务内容及使用须知',
    text: [{
      subText: [
        {
          fourTitle: '1.吉日历服务平台向用户提供日历及相关生活信息查询、分享、传送、获取服务。包括但不限于日历视图、星座运势、八字测算、黄历信息查询、新闻资讯更新等服务。在该服务过程当中,我们会对您的信息进行保密，请您放心使用。',
        },

        {
          fourTitle: '2.平台为您提供多种服务，您可以通过“设置”进行浏览并选择关闭或开启这些服务。',
        },

        {
          fourTitle: '3.您充分了解并同意，平台对您在吉日历应用上发布的任何公开信息具有使用权。使用范围包括，吉日历服务平台、平台入驻的其他第三方（广告商或者其他服务提供方等）以及其他法律允许的范围和区域。',
        },

        {
          fourTitle: '4、平台提供的服务中可能包括广告，您同意在使用过程中显示吉日历和第三方供应商、合作伙伴提供的广告。',
        },

        {
          fourTitle: '5、在提供服务时，根据使用服务的具体功能，平台可能需要收集部分用户信息，如GPS定位等相关信息，平台会采取行业领先的安全防护措施，保护用户的个人信息，不会向第三方透露您的信息，除非得到您的授权。',
        },

        {
          fourTitle: '6. 任何通过使用平台链接到的第三方网页均系他人制作或提供，您可根据您的个人喜好从该第三方网页上获得视频及资讯享用服务，平台对其合法性概不负责，亦不承担任何法律责任。',
        },

        {
          fourTitle: '7.用户有权在本协议范围内获取平台的日历信息服务、推送提醒以及平台第三方提供的其他服务（八字测算、星座运势、新闻资讯等信息）。',
        },

        {
          fourTitle: '8.用户有权利对平台提供的服务进行评论、提出意见，但评论内容的真实性、合法性由用户负责。',
        },

        {
          fourTitle: '9.平台尊重用户的自由选择权，如果您不愿意继续使用平台提供的服务，您可以随时注销平台账号，删除您在平台留下的所有信息。',
        },

        {
          fourTitle: '10.吉日历平台接入的其他服务（八字测算等）意在为您提供命理测算类或者其他资讯服务，您点击平台上的相关链接将直接进入第三方服务界面。这些服务均由第三方制作和提供，这些服务内容的准确性、真实性以及合法性均由第三方负责，与吉日历服务平台无关。平台不对测试结果负责，该结果不应作为您真正的人生指导策划，仅作娱乐参考，请勿沉迷，否则后果自负。',
        },

        {
          fourTitle: '11.用户不得将平台以及其他第三方提供的服务结果用于任何非法用途。',
        },

        {
          fourTitle: '12.用户使用吉日历服务时知晓，平台不保证链接网页的真实性、准确性以及完整性，也不作任何承诺，对信息的延误、失误和遗漏不承担任何责任。',
        },

        {
          fourTitle: '13.平台第三方提供的产品侵害任何单位、个人或者用户的任何权力产生的责任均由该第三方承担。',
        },

        {
          fourTitle: '14.您使用平台第三方提供的服务存在的任何风险以及后果将完全由您本人或者第三方承担，吉日历服务平台不负任何责任。',
        },

      ],
    },
    ],
  },

  {
    subTitle: '二、用户的承诺与保证',
    text: [{
      subText: [
        {
          fourTitle: '1.不为任何非法目的而使用本网络服务系统；不以任何形式使用平台服务侵犯平台以及入驻第三方平台的商业利益，包括并不限于发布非经平台许可的商业广告；不得利用平台网络服务系统进行任何可能对互联网或移动网正常运转造成不利影响的行为；',
        },

        {
          fourTitle: '2.不利用吉日历提供的服务从事以下活动：',
          threeText: [
            '（1）未经允许，进入计算机信息网络或者使用计算机信息网络资源的；',
            '（2）未经允许，对计算机信息网络功能进行删除、修改或者增加的；',
            '（3）未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；',
            '（4）故意制作、传播计算机病毒等破坏性程序的；',
            '（5）其他危害计算机信息网络安全的行为。',
            '（6）如因用户利用平台提供的网络服务进行了侵犯了任何第三方的合法权益（包括但不限于专利权、商标权、著作权及著作权邻接权、肖像权、隐私权、名誉权等）的行为而导致平台或平台第三方遭受任何投诉、举报、质询、索赔、诉讼；或者因此遭受任何名誉、声誉或者财产上的损失，用户应积极采取一切可能的措施，以保证平台或者平台第三方免受上述索赔、诉讼的影响，同时用户应对平台或者平台第三方因此遭受的直接及间接经济损失负有全部的损害赔偿责任。',
          ],
        },

        {
          fourTitle: '3.不利用平台传播如下内容：',
          threeText: [
            '（1）反对宪法所确定的基本原则的；',
            '（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；',
            '（3）损害国家荣誉和利益的；',
            '（4）煽动民族仇恨、民族歧视，破坏民族团结的；',
            '（5）破坏国家宗教政策，宣扬邪教和封建迷信的；',
            '（6）散布谣言，扰乱社会秩序，破坏社会稳定的；',
            '（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；',
            '（8）侮辱或者诽谤他人，侵害他人合法权益的；',
            '（9）含有法律、行政法规禁止的其他内容的信息。',
          ],
        },

        {
          fourTitle: '4.不会请求、收集、索取或以其他方式获取对平台帐号、密码或其他身份验证凭据的访问权。',
        },

        {
          fourTitle: '5.用户保证，不得并禁止直接或间接的：',
          threeText: [
            '（1）删除、隐匿、改变平台上显示或其中包含的任何专利、版权、商标或其他所有权声明；',
            '（2）以任何方式干扰或企图干扰平台网站任何部分或功能的正常运行；',
            '（3）避开、尝试避开或声称能够避开任何内容保护机制或者平台服务数据度量工具；',
            '（4）未获得平台事先书面同意以书面格式或图形方式使用源平台或者平台第三方的任何注册或未注册的商品、服务标志、公司徽标(LOGO)、URL或其他标志；',
            '（5）使用任何标志，包括但不限于以对此类标志的所有者的权利的玷污、削弱和损害的方式使用平台或者其关联公司、平台第三方的标志。用户不得利用网络技术导出任何用户信息，否则，必须在获取任何用户信息或其他平台服务内容后的 24 小时内停止使用和删除它们，平台或者其他第三方有权追责。',
            '（6）用户违反上述任何一款的保证，平台均有权就其情节，对其做出警告、屏蔽、直至取消资格的处罚；如因用户违反上述保证而给平台或者关联方、平台第三方造成损失，用户自行负责承担一切法律责任并赔偿损失。',
          ],
        },
      ],
    },


    ],
  },


  {
    subTitle: '三、知识产权条款',
    text: [{
      subText: [
        {
          fourTitle: '1、知识产权声明',
          threeText: [
            '（1）本协议定义的信息内容包括：文字、软件、声音、相片、录像、图表；在广告中的全部内容；平台为用户提供的所有服务（八字测算、黄历、新闻资讯等），所有这些内容受版权、商标权、和其它知识产权和所有权法律的保护。所以，用户只能在吉日历服务平台和广告商授权下才能使用这些内容，而不能擅自复制、修改、编纂这些内容、或创造与内容有关的衍生产品。',
            '（2）本“软件”是由平台方开发。“软件”的一切版权、商标权、专利权、商业秘密等知识产权，以及与“软件”相关的所有信息内容，包括但不限于：文字表述及其组合、图标、图饰、图表、色彩、界面设计、版面框架、有关数据、印刷材料、或电子文档等均受中华人民共和国著作权法、商标法、专利法、反不正当竞争法和相应的国际条约以及其他知识产权法律法规的保护，除涉及第三方授权的软件或技术外，平台方享有上述知识产权。用户不得对该软件进行反向工程（reverse engineer）、反向编译（decompile）或反汇编（disassemble），或以其他方式发现其原始编码，以及实施任何涉嫌侵害著作权的行为。',
          ],
        },

        {
          fourTitle: '2.平台保留对以下各项内容、信息的使用权或者完全的、不可分割的所有权及知识产权：',
          threeText: [
            '（1）平台及其所有元素，包括但不限于所有内容、数据、技术、软件、代码、用户界面以及与其相关的任何衍生作品；',
            '（2）用户向平台提供的与该服务相关的任何信息及反馈。',
          ],
        },

        {
          fourTitle: '3.未经平台方的书面同意，用户不得为任何营利性或非营利性的目的自行实施、利用、转让或许可任何三方实施、利用、转让上述知识产权，平台方保留追究上述未经许可行为的权利。',
        },

        {
          fourTitle: '4.未经平台同意，上述资料均不得在任何媒体直接或间接发布、播放、出于播放或发布目的而改写或再发行，或者被用于其他任何商业目的。平台不就由上述资料产生或在传送过程中产生的延误、不准确、错误和遗漏或从中产生或由此产生的任何损害赔偿，以任何形式向用户或任何第三方负法律、经济责任。',
        },

      ],
    },

    ],
  },


  {
    subTitle: '四、 隐私保护',
    subHeaderText: '平台充分尊重用户信息的保护，用户隐私政策中介绍了您在使用吉日历平台的服务时，我们如何处理您的用户信息。您同意并接受，我们可以按照该政策进行相应的处理。',
  },

  {
    subTitle: '五、 免责声明',
    text: [{
      subText: [
        {
          fourTitle: '1. 鉴于网络服务的特殊性，您同意平台有权随时变更、中断或终止部分或全部的网络服务。如变更、中断或终止的网络服务属于免费网络服务，吉日历服务平台无需通知您，也无需对任何用户或任何第三方承担任何责任。',
        },

        {
          fourTitle: '2. 您理解，平台需要定期或不定期地对提供网络服务的平台进行检修或者维护，如因此类情况而造成收费网络服务在合理时间内的中断，吉日历服务平台无需为此承担任何责任，但平台会尽可能事先进行通告。',
        },

        {
          fourTitle: '3. 您在平台中或通过平台所传送的任何内容并不反映平台的观点或政策，平台对此不承担任何责任。您须对在平台上所传送信息的真实性、合法性、无害性、有效性等全权负责，与您所传播的信息相关的任何法律责任由您自行承担，与平台无关。',
        },

        {
          fourTitle: '4. 您应对吉日历服务平台中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。吉日历服务平台无法且不会对因用户行为而导致的任何损失或损害承担责任。',
        },

        {
          fourTitle: '5. 平台可在任何时候为任何原因变更本服务或删除其部分功能。吉日历服务平台可在任何时候取消或终止对您的服务。平台取消或终止服务的决定不需要理由或通知您。一旦服务取消，您使用本服务的权利立即终止。一旦本服务取消或终止，您在本服务中储存的任何信息可能无法恢复。',
        },

        {
          fourTitle: '6.吉日历服务平台不保证（包括但不限于）：',
          threeText: [
            '（1）本服务适合用户的所有使用要求；',
            '（2）本服务不受干扰，及时、安全、可靠或不出现错误；您经由本服务取得的任何服务或其他材料符合您所有的期望。',
          ],
        },

        {
          fourTitle: '7.用户使用经由平台获取的任何信息，其风险由用户自行承担。',
        },

        {
          fourTitle: '8.基于以下原因而造成的利润、商业信誉、资料损失或其他有形或无形损失，吉日历服务平台不承担任何直接、间接的赔偿：',
          threeText: [
            '（1）对本服务的使用或无法使用；',
            '（2）经由本服务购买或取得的任何产品、资料或服务；',
            '（3）用户资料遭到未授权的使用或修改；及其他与本服务相关的事宜。',
          ],
        },

        {
          fourTitle: '7.由于用户授权第三方（包括第三方应用）访问/使用其本服务所导致的纠纷或损失，应由用户自行负责，与服务提供方无关。',
        },

      ],
    },

    ],
  },


  {
    subTitle: '六、 其他',
    text: [{
      subText: [
        {
          fourTitle: '1. 本协议最终解释权归服务提供方所有。',
        },

        {
          fourTitle: '2. 本协议一经公布即生效，服务提供方有权随时对协议内容进行修改。如果不同意本协议相关条款所做的修改，您有权停止使用网络服务。如果您继续使用网络服务，则视为您接受吉日历平台对本协议相关条款所做的修改。您可以在吉日历页面随时查看本协议的内容。',
        },

        {
          fourTitle: '3. 本协议的订立、执行和解释及争议的解决均应适用中国法律并受中国法院管辖。如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均同意向本协议订立地上海市浦东新区有管辖权的人民法院提起诉讼。',
        },

        {
          fourTitle: '4. 本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。',
        },

        {
          fourTitle: '5. 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。',
        },

      ],
    },

    ],
  },

  ],
};

export const userPrivacy = {
  title: '用户协议与隐私政策',
  paragraph: [{
    subHeaderText: '本《隐私政策》（以下简称“本政策”）是吉日历运营方（以下简称“我们”）与用户（以下简称“您”）之间关于如何收集、使用以及处理您的个人信息和隐私信息的法律约束。希望您仔细阅读本政策，详细了解我们对信息的收集、使用方式，以便您更好地了解我们的服务并作出适当的选择。您使用或继续使用我们的服务，即意味着同意我们按照本《隐私政策》收集、使用、储存、共享、转让和公开披露您的相关信息。除另有约定外，本政策所用术语与《吉日历用户注册协议》中的术语具有相同的涵义。本政策适用于平台所有用户，您使用本平台的服务，即视为您接受并认同本政策中所述的下列内容。要点如下：',
  },
  {
    text: [{
      subText: [{
        threeText: [
          '一、关于如何收集和使用您的个人信息',
          '二、关于如何储存、管理和保护您的个人信息',
          '三、关于共享、转让、公开披露您的个人信息',
          '四、关于您如何访问和控制您的个人信息',
          '五、您的义务以及享有的权力',
          '六、如何与我们取得联系',
          '七、法律适用及争议解决',
        ],
      }],
    }],
  },
  {
    subTitle: '一、关于如何收集和使用您的个人信息',
    text: [{
      threeTitle: '（一）如何收集您的个人信息',
      threeHeaderText: '我们始终在法律的范围内，不违背社会的公序良俗，本着自愿、合法、正当以及必要的原则，仅收集能够实现产品功能、为您提供服务所需的必要信息。此类信息会在您注册和使用我们的服务时被收集。您的个人信息包括但不限于您的微信昵称或者姓名、头像、地区以及性别、个人生物识别信息等以电子或者其他方式记录的能够单独或者与其他信息结合识别个人身份的各种信息。包括：',
      subText: [
        {
          fourTitle: '1.您在使用我们的服务时主动提供的信息',
          threeText: [
            '授权微信登陆吉日历平台时，我们在符合相关法律和法规规定的前提下读取的您在该第三方平台上登记、公布、记录的公开信息（包括但不限于昵称、头像、关注用户列表等）视为您主动提供的个人信息。对于我们要求但该第三方平台无法提供的个人信息，我们仍可以要求您补充提供。我们可能从第三方获取您的上述信息的目的是为了记住您作为吉日历用户的登录身份，并向您提供个性化推荐，以便于我们向您提供更优质的产品服务。您可以在使用第三方帐号登录我们时选择授权吉日历可获取的个人信息的范围，或在使用吉日历的过程中通过设置拒绝或管理我们获取您个人信息的权限。但请注意，如果停止某些权限，您有可能无法享受最佳的服务体验，某些服务也可能无法正常使用。使用吉日历服务时您主动上传的信息、分享的图片视为您同意我们按照本政策所述的目的和方式来处理您的个人信息。',
          ],
        },

        {
          fourTitle: '2.我们在您使用服务时获取的信息',
          threeText: [
            '（1）日志信息。当您使用我们的服务时，我们可能会自动收集相关信息并存储为服务日志信息。',
            '（2）设备信息。当您使用我们的服务时，我们可能会获取您的设备型号、操作系统版本、唯一设备标识符、电池、信号强度、IP地址等信息。',
            '（3）服务日志信息。您在使用我们服务时搜索、查看的信息、服务故障信息、引荐网址等信息。',
            '（4）通讯日志信息。您在使用我们服务时曾经通讯的账户、通讯时间和时长。',
            '（5）位置信息。当您开启设备定位功能并使用我们基于位置提供的相关服务时，我们会收集有关您位置的信息。该信息属于敏感信息，拒绝提供该信息仅会使您无法使用与位置信息相关的功能，但不影响您正常使用吉日历的其他功能。在您使用服务时，我们可能会通过IP地址 、GPS、WiFi或基站等途径获取您的地理位置信息；',
            '（6）联系方式信息。当您向吉日历进行帐号申诉或参与营销活动或选购某类服务时，为了方便与您联系或帮助您解决问题，我们会收集并记录您的姓名、手机号码、电子邮件及其他联系方式等个人信息。如您拒绝提供上述信息，我们可能无法向您及时反馈投诉结果或向您邮寄礼品（如有）或将无法提供相关服务。',
            '（7）其他相关信息，为了帮助您更好地使用我们的产品或服务，我们会收集相关信息。如用户共享的信息，当您在吉日历中使用第三方提供的服务时，您同意该第三方收集您的帐号名称、头像及其他提供服务所必须的个人信息、登录时间及日志信息。如果您拒绝第三方在提供服务时收集上述信息，将可能导致您无法在吉日历中使用该第三方服务。请您仔细阅读第三方合作伙伴服务的用户协议或隐私政策后使用第三方的服务。',
          ],
        },

        {
          fourTitle: '3.征得授权同意的例外',
          fourHeaderText: '根据相关法律法规的规定，以下情形中收集您的个人信息无需征得您的授权同意：',
          threeText: [
            '（1）涉及国家安全与利益、社会公共利益；',
            '（2）与犯罪侦查有关的相关活动；',
            '（3）出于维护您或他人的生命财产安全但在特殊情况下无法获得您的及时授权；',
            '（4）从其他合法公开的渠道中收集您的个人信息；',
            '（5）法律法规规定的其他情形。',
          ],
        },
      ],
    },
    {
      threeTitle: '（二）如何使用您的个人信息',
      threeHeaderText: '我们严格遵守法律法规的规定及与您的约定，将收集的信息仅限于以下用途及目的。若我们超出以下用途及目的使用您的信息，我们将再次向您进行说明，并征得您的同意。',
      subText: [
        {
          fourTitle: '1.向您提供服务',
          threeText: [],
        },

        {
          fourTitle: '2.满足您的个性化需求',
          threeText: [],
        },

        {
          fourTitle: '3.产品开发和服务优化。当我们的系统发生故障时，我们会记录和分析系统故障时产生的信息，优化我们的服务。',
          threeText: [],
        },

        {
          fourTitle: '3.产品开发和服务优化。当我们的系统发生故障时，我们会记录和分析系统故障时产生的信息，优化我们的服务。',
          threeText: [],
        },

        {
          fourTitle: '4.在我们提供服务时，我们会将您的信息用于身份验证、安全防范、反诈骗监测、存档备份、客户的安全服务等用途。您下载或安装的安全软件会对恶意程序或病毒进行检测，或为您识别诈骗信息。',
          threeText: [],
        },

        {
          fourTitle: '5.向您推荐您可能感兴趣的广告、资讯等（包括但不限于提供与您更加相关的广告以替代普遍投放的广告）。',
          threeText: [],
        },

        {
          fourTitle: '6.我们可能将您的信息用于用户行为分析、广告投放监测等，以便更好地向您提供服务，并进而评估、改善我们的广告投放和其他促销及推广活动的效果。',
          threeText: [],
        },

        {
          fourTitle: '7.管理软件。例如，进行软件认证、软件升级等。',
          threeText: [],
        },

        {
          fourTitle: '8.邀请您参与有关我们服务的调查。',
          threeText: [],
        },

        {
          fourTitle: '9.帮助我们设计新服务，提升现有服务体验。',
          threeText: [],
        },

        {
          fourTitle: '10.开展内部审计、数据分析和研究，促进改善我们的产品、服务及与用户之间的沟通。',
          threeText: [],
        },
      ],
    },
    ],
  },


  {
    subTitle: '二、关于如何储存、管理和保护您的个人信息',
    text: [

      {
        threeTitle: '（一）个人信息的储存',
        subText: [
          {
            fourTitle: '1.我们遵守法律法规的规定，将境内收集的用户个人信息存储于境内。',
            threeText: [],
          },

          {
            fourTitle: '2.我们仅为实现目的所必需的最短时间保留您的个人信息。但在下列情况下，我们有能因需符合法律要求，更改个人信息的存储时间：',
            threeText: [
              '（1）为遵守适用的法律法规等有关规定；',
              '（2）为遵守法院判决、裁定或其他法律程序的规定；',
              '（3）为遵守相关政府机关或法定授权组织的要求；',
              '（4）我们有理由确信需要遵守法律法规等有关规定；',
              '（5）为执行相关服务协议或本政策、维护社会公共利益，为保护们的客户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益所合理必需的用途。',
              '（6）当我们的产品或服务发生停止运营的情形时，我们将采取例如推送通知、公告等形式通知您，并在合理的期限内删除或匿名化处理您的个人信息。',
            ],
          },
        ],
      },

      {
        threeTitle: '（二）个人信息的管理和保护',
        subText: [
          {
            fourTitle: '1.我们仅在本政策所述目的所必需期间和法律法规要求的时限内保留您的个人信息，但为了遵守适用的法律法规、法院判决或裁定、其他有权机关的要求、维护公共利益等目的，我们可能会将个人信息保存时间予以适当延长。',
            threeText: [],
          },

          {
            fourTitle: '2.我们为您的信息提供相应的安全保障，以防止信息的丢失、不当使用、未经授权访问或披露，并严格遵守法律法规保护用户的通信秘密。',
            threeText: [],
          },

          {
            fourTitle: '3.我们将在合理的安全水平内使用各种安全保护措施以保护您的个人信息。例如，在某些服务中，我们将利用加密技术匿名化处理等手段来保护您向我们提供的个人信息。',
            threeText: [],
          },

          {
            fourTitle: '4.我们建立专门的管理制度、流程和组织确保信息安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审查。',
            threeText: [],
          },

          {
            fourTitle: '5.请您理解，由于技术的限制以及可能存在的各种恶意手段，现有技术以及风险防范的存在局限，即便我们已经尽量加强安全措施，也无法始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的情况而发生问题。若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告等形式告知您。',
            threeText: [],
          },

        ],
      },

    ],
  },


  {
    subTitle: '三、关于共享、转让、公开披露您的个人信息',
    subHeaderText: '我们遵照法律法规的规定，对信息的分享进行严格限制，在下述情境我们可能分享您的信息：',
    text: [

      {
        threeTitle: '（一）共享',
        threeHeaderText: '仅为实现外部处理的目的，我们可能会与第三方合作伙伴（第三方服务供应商、关联公司、广告合作伙伴、应用开发者等分享）。让他们按照我们的说明、隐私政策以及其他相关的保密和安全措施来为我们处理上述信息，包括向您提供我们的服务，理解、维持及改善我们的服务等，我们会将您的个人信息采取加、匿名化处理等手段保障您的信息安全：',
      },

      {
        threeTitle: '（二）转让',
        threeHeaderText: '我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：',
        subText: [
          {
            fourTitle: '在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；在涉及合并、收购或破产清算资产转让等交易时，随着我们业务的持续发展，我们以及我们的关联公司有可能进行合并、收购、资产转让或类似的交易，而您的个人信息有可能作为此类交易的一部分而被转移。我们将通过推送通知、公告等形式告知您相关情形，我们会要求新的持有您个人信息的公司、组织继续受此不低于隐私政策保护标准的约束，否则我们将要求该公司、组织重新向您征求授权同意。',
          },
        ],
      },

      {
        threeTitle: '（三）公开披露',
        threeHeaderText: '我们仅会在以下情况下，且采取符合法律和业界标准的安全防护措施的前提下，才会公开披露您的个人信息',
        subText: [
          {
            fourTitle: '',
            threeText: [
              '（1）获得您的明确同意；',
              '（2）基于法律法规、法律程序、诉讼或政府主管部门强制性要求。',
              '（3）遵守相关政府机关或其他法定授权组织的要求；',
              '（4）我们有理由确信需要遵守法律法规等有关规定；',
              '（5）为执行相关服务协议或本政策；',
              '（6）我们认为为遵守适用的法律法规、维护社会公共利益、或保护我们或我们的集团公司、我们的客户、其他用户或雇员的人身和财产安全或合法权益所合理必需的。',
            ],
          },
        ],
      },
    ],
  },

  {
    subTitle: '四、关于您如何访问和控制您的个人信息',
    subHeaderText: '我们将尽可能采取适当的技术手段，保证您可以访问、更新和更正您的注册信息或使用我们的服务时提供的其他个人信息。在访问、更新、更正和删除您的个人信息时，我们可能会要求您进行身份验证，以保障您的账户安全。您访问、修改和删除个人信息的范围和方式将取决于您使用的具体服务。例如，若您在使用地理位置相关服务时，希望停止分享您的地理位置信息，您可通过手机定位关闭功能、软硬件服务商及通讯服务提供商的关闭方式停止分享，建议您仔细阅读本政策。',
    text: [

      {
        threeTitle: '如您在访问、更新、更正和删除您的个人信息时存在任何疑问，请及时与我们联系。',
      },

    ],
  },

  {
    subTitle: '五、您的义务以及享有的权力',
    text: [

      {
        threeTitle: '（一）您有权根据本隐私政策第四条的规定访问以及控制您的个人信息。',
      },

      {
        threeTitle: '（二）当您的个人信息有变更可能会影响到您使用我们的服务时，您有权对您的信息进行补充、更正、删除。',
      },

      {
        threeTitle: '（三）如果您对本隐私政策修改的任何内容存有疑问，您有权联系我们并要求我们给出合理解释。',
      },

      {
        threeTitle: '（四）当您基于任何理由不再使用我们的服务时，您有权注销平台账户或者取消微信授权登陆，并删除您所有的信息。',
      },

      {
        threeTitle: '（五）因我们平台可能会接入第三方（服务供应商、关联公司、广告合作伙伴、应用开发者等），对该第三方在我们平台发布的所有信息，不论你是否注销平台账户或者取消授权，您应始终保密，未经我们或者第三方授权，不得进行转载、抄袭或者以其他方式复制。否则，我们以及第三方平台有权依法追究您的法律责任。',
      },

    ],
  },

  {
    subTitle: '六、如何与我们取得来联系',
    subHeaderText: '当您对本政策有任何疑问，可以通过吉日历界面的客服与我们联系或者留言。我们将尽快审核所涉问题，并在验证您的用户身份后的即时予以回复。',
  },

  {
    subTitle: '七、法律适用及争议解决',
    subHeaderText: '本隐私政策的订立、执行、解释及争议的解决均应适用中华人民共和国法律。',
    text: [
      {
        threeTitle: '因本隐私政策引起的或与本隐私政策有关的任何争议，各方应友好协商解决；协商不成的，任何一方均可将有关争议提交至本协议订立地上海市浦东新区有管辖权的人民法院处理。',
      },
    ],
  },

  ],
};

export const userPrivacy1 = {
  title: '用户协议与隐私政策',
  paragraph: [{
    subHeaderText: '本《隐私政策》（以下简称“本政策”）是诸葛万年历运营方（以下简称“我们”）与用户（以下简称“您”）之间关于如何收集、使用以及处理您的个人信息和隐私信息的法律约束。希望您仔细阅读本政策，详细了解我们对信息的收集、使用方式，以便您更好地了解我们的服务并作出适当的选择。您使用或继续使用我们的服务，即意味着同意我们按照本《隐私政策》收集、使用、储存、共享、转让和公开披露您的相关信息。除另有约定外，本政策所用术语与《诸葛万年历用户注册协议》中的术语具有相同的涵义。本政策适用于平台所有用户，您使用本平台的服务，即视为您接受并认同本政策中所述的下列内容。要点如下：',
  },
  {
    text: [{
      subText: [{
        threeText: [
          '一、关于如何收集和使用您的个人信息',
          '二、关于如何储存、管理和保护您的个人信息',
          '三、关于共享、转让、公开披露您的个人信息',
          '四、关于您如何访问和控制您的个人信息',
          '五、您的义务以及享有的权力',
          '六、如何与我们取得联系',
          '七、法律适用及争议解决',
        ],
      }],
    }],
  },
  {
    subTitle: '一、关于如何收集和使用您的个人信息',
    text: [{
      threeTitle: '（一）如何收集您的个人信息',
      threeHeaderText: '我们始终在法律的范围内，不违背社会的公序良俗，本着自愿、合法、正当以及必要的原则，仅收集能够实现产品功能、为您提供服务所需的必要信息。此类信息会在您注册和使用我们的服务时被收集。您的个人信息包括但不限于您的微信昵称或者姓名、头像、地区以及性别、个人生物识别信息等以电子或者其他方式记录的能够单独或者与其他信息结合识别个人身份的各种信息。包括：',
      subText: [
        {
          fourTitle: '1.您在使用我们的服务时主动提供的信息',
          threeText: [
            '授权微信登陆诸葛万年历平台时，我们在符合相关法律和法规规定的前提下读取的您在该第三方平台上登记、公布、记录的公开信息（包括但不限于昵称、头像、关注用户列表等）视为您主动提供的个人信息。对于我们要求但该第三方平台无法提供的个人信息，我们仍可以要求您补充提供。我们可能从第三方获取您的上述信息的目的是为了记住您作为诸葛万年历用户的登录身份，并向您提供个性化推荐，以便于我们向您提供更优质的产品服务。您可以在使用第三方帐号登录我们时选择授权诸葛万年历可获取的个人信息的范围，或在使用诸葛万年历的过程中通过设置拒绝或管理我们获取您个人信息的权限。但请注意，如果停止某些权限，您有可能无法享受最佳的服务体验，某些服务也可能无法正常使用。使用诸葛万年历服务时您主动上传的信息、分享的图片视为您同意我们按照本政策所述的目的和方式来处理您的个人信息。',
          ],
        },

        {
          fourTitle: '2.我们在您使用服务时获取的信息',
          threeText: [
            '（1）日志信息。当您使用我们的服务时，我们可能会自动收集相关信息并存储为服务日志信息。',
            '（2）设备信息。当您使用我们的服务时，我们可能会获取您的设备型号、操作系统版本、唯一设备标识符、电池、信号强度、IP地址等信息。',
            '（3）服务日志信息。您在使用我们服务时搜索、查看的信息、服务故障信息、引荐网址等信息。',
            '（4）通讯日志信息。您在使用我们服务时曾经通讯的账户、通讯时间和时长。',
            '（5）位置信息。当您开启设备定位功能并使用我们基于位置提供的相关服务时，我们会收集有关您位置的信息。该信息属于敏感信息，拒绝提供该信息仅会使您无法使用与位置信息相关的功能，但不影响您正常使用诸葛万年历的其他功能。在您使用服务时，我们可能会通过IP地址 、GPS、WiFi或基站等途径获取您的地理位置信息；',
            '（6）联系方式信息。当您向诸葛万年历进行帐号申诉或参与营销活动或选购某类服务时，为了方便与您联系或帮助您解决问题，我们会收集并记录您的姓名、手机号码、电子邮件及其他联系方式等个人信息。如您拒绝提供上述信息，我们可能无法向您及时反馈投诉结果或向您邮寄礼品（如有）或将无法提供相关服务。',
            '（7）其他相关信息，为了帮助您更好地使用我们的产品或服务，我们会收集相关信息。如用户共享的信息，当您在诸葛万年历中使用第三方提供的服务时，您同意该第三方收集您的帐号名称、头像及其他提供服务所必须的个人信息、登录时间及日志信息。如果您拒绝第三方在提供服务时收集上述信息，将可能导致您无法在诸葛万年历中使用该第三方服务。请您仔细阅读第三方合作伙伴服务的用户协议或隐私政策后使用第三方的服务。',
          ],
        },

        {
          fourTitle: '3.征得授权同意的例外',
          fourHeaderText: '根据相关法律法规的规定，以下情形中收集您的个人信息无需征得您的授权同意：',
          threeText: [
            '（1）涉及国家安全与利益、社会公共利益；',
            '（2）与犯罪侦查有关的相关活动；',
            '（3）出于维护您或他人的生命财产安全但在特殊情况下无法获得您的及时授权；',
            '（4）从其他合法公开的渠道中收集您的个人信息；',
            '（5）法律法规规定的其他情形。',
          ],
        },
      ],
    },
    {
      threeTitle: '（二）如何使用您的个人信息',
      threeHeaderText: '我们严格遵守法律法规的规定及与您的约定，将收集的信息仅限于以下用途及目的。若我们超出以下用途及目的使用您的信息，我们将再次向您进行说明，并征得您的同意。',
      subText: [
        {
          fourTitle: '1.向您提供服务',
          threeText: [],
        },

        {
          fourTitle: '2.满足您的个性化需求',
          threeText: [],
        },

        {
          fourTitle: '3.产品开发和服务优化。当我们的系统发生故障时，我们会记录和分析系统故障时产生的信息，优化我们的服务。',
          threeText: [],
        },

        {
          fourTitle: '3.产品开发和服务优化。当我们的系统发生故障时，我们会记录和分析系统故障时产生的信息，优化我们的服务。',
          threeText: [],
        },

        {
          fourTitle: '4.在我们提供服务时，我们会将您的信息用于身份验证、安全防范、反诈骗监测、存档备份、客户的安全服务等用途。您下载或安装的安全软件会对恶意程序或病毒进行检测，或为您识别诈骗信息。',
          threeText: [],
        },

        {
          fourTitle: '5.向您推荐您可能感兴趣的广告、资讯等（包括但不限于提供与您更加相关的广告以替代普遍投放的广告）。',
          threeText: [],
        },

        {
          fourTitle: '6.我们可能将您的信息用于用户行为分析、广告投放监测等，以便更好地向您提供服务，并进而评估、改善我们的广告投放和其他促销及推广活动的效果。',
          threeText: [],
        },

        {
          fourTitle: '7.管理软件。例如，进行软件认证、软件升级等。',
          threeText: [],
        },

        {
          fourTitle: '8.邀请您参与有关我们服务的调查。',
          threeText: [],
        },

        {
          fourTitle: '9.帮助我们设计新服务，提升现有服务体验。',
          threeText: [],
        },

        {
          fourTitle: '10.开展内部审计、数据分析和研究，促进改善我们的产品、服务及与用户之间的沟通。',
          threeText: [],
        },
      ],
    },
    ],
  },


  {
    subTitle: '二、关于如何储存、管理和保护您的个人信息',
    text: [

      {
        threeTitle: '（一）个人信息的储存',
        subText: [
          {
            fourTitle: '1.我们遵守法律法规的规定，将境内收集的用户个人信息存储于境内。',
            threeText: [],
          },

          {
            fourTitle: '2.我们仅为实现目的所必需的最短时间保留您的个人信息。但在下列情况下，我们有能因需符合法律要求，更改个人信息的存储时间：',
            threeText: [
              '（1）为遵守适用的法律法规等有关规定；',
              '（2）为遵守法院判决、裁定或其他法律程序的规定；',
              '（3）为遵守相关政府机关或法定授权组织的要求；',
              '（4）我们有理由确信需要遵守法律法规等有关规定；',
              '（5）为执行相关服务协议或本政策、维护社会公共利益，为保护们的客户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益所合理必需的用途。',
              '（6）当我们的产品或服务发生停止运营的情形时，我们将采取例如推送通知、公告等形式通知您，并在合理的期限内删除或匿名化处理您的个人信息。',
            ],
          },
        ],
      },

      {
        threeTitle: '（二）个人信息的管理和保护',
        subText: [
          {
            fourTitle: '1.我们仅在本政策所述目的所必需期间和法律法规要求的时限内保留您的个人信息，但为了遵守适用的法律法规、法院判决或裁定、其他有权机关的要求、维护公共利益等目的，我们可能会将个人信息保存时间予以适当延长。',
            threeText: [],
          },

          {
            fourTitle: '2.我们为您的信息提供相应的安全保障，以防止信息的丢失、不当使用、未经授权访问或披露，并严格遵守法律法规保护用户的通信秘密。',
            threeText: [],
          },

          {
            fourTitle: '3.我们将在合理的安全水平内使用各种安全保护措施以保护您的个人信息。例如，在某些服务中，我们将利用加密技术匿名化处理等手段来保护您向我们提供的个人信息。',
            threeText: [],
          },

          {
            fourTitle: '4.我们建立专门的管理制度、流程和组织确保信息安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审查。',
            threeText: [],
          },

          {
            fourTitle: '5.请您理解，由于技术的限制以及可能存在的各种恶意手段，现有技术以及风险防范的存在局限，即便我们已经尽量加强安全措施，也无法始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的情况而发生问题。若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告等形式告知您。',
            threeText: [],
          },

        ],
      },

    ],
  },


  {
    subTitle: '三、关于共享、转让、公开披露您的个人信息',
    subHeaderText: '我们遵照法律法规的规定，对信息的分享进行严格限制，在下述情境我们可能分享您的信息：',
    text: [

      {
        threeTitle: '（一）共享',
        threeHeaderText: '仅为实现外部处理的目的，我们可能会与第三方合作伙伴（第三方服务供应商、关联公司、广告合作伙伴、应用开发者等分享）。让他们按照我们的说明、隐私政策以及其他相关的保密和安全措施来为我们处理上述信息，包括向您提供我们的服务，理解、维持及改善我们的服务等，我们会将您的个人信息采取加、匿名化处理等手段保障您的信息安全：',
      },

      {
        threeTitle: '（二）转让',
        threeHeaderText: '我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：',
        subText: [
          {
            fourTitle: '在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；在涉及合并、收购或破产清算资产转让等交易时，随着我们业务的持续发展，我们以及我们的关联公司有可能进行合并、收购、资产转让或类似的交易，而您的个人信息有可能作为此类交易的一部分而被转移。我们将通过推送通知、公告等形式告知您相关情形，我们会要求新的持有您个人信息的公司、组织继续受此不低于隐私政策保护标准的约束，否则我们将要求该公司、组织重新向您征求授权同意。',
          },
        ],
      },

      {
        threeTitle: '（三）公开披露',
        threeHeaderText: '我们仅会在以下情况下，且采取符合法律和业界标准的安全防护措施的前提下，才会公开披露您的个人信息',
        subText: [
          {
            fourTitle: '',
            threeText: [
              '（1）获得您的明确同意；',
              '（2）基于法律法规、法律程序、诉讼或政府主管部门强制性要求。',
              '（3）遵守相关政府机关或其他法定授权组织的要求；',
              '（4）我们有理由确信需要遵守法律法规等有关规定；',
              '（5）为执行相关服务协议或本政策；',
              '（6）我们认为为遵守适用的法律法规、维护社会公共利益、或保护我们或我们的集团公司、我们的客户、其他用户或雇员的人身和财产安全或合法权益所合理必需的。',
            ],
          },
        ],
      },
    ],
  },

  {
    subTitle: '四、关于您如何访问和控制您的个人信息',
    subHeaderText: '我们将尽可能采取适当的技术手段，保证您可以访问、更新和更正您的注册信息或使用我们的服务时提供的其他个人信息。在访问、更新、更正和删除您的个人信息时，我们可能会要求您进行身份验证，以保障您的账户安全。您访问、修改和删除个人信息的范围和方式将取决于您使用的具体服务。例如，若您在使用地理位置相关服务时，希望停止分享您的地理位置信息，您可通过手机定位关闭功能、软硬件服务商及通讯服务提供商的关闭方式停止分享，建议您仔细阅读本政策。',
    text: [

      {
        threeTitle: '如您在访问、更新、更正和删除您的个人信息时存在任何疑问，请及时与我们联系。',
      },

    ],
  },

  {
    subTitle: '五、您的义务以及享有的权力',
    text: [

      {
        threeTitle: '（一）您有权根据本隐私政策第四条的规定访问以及控制您的个人信息。',
      },

      {
        threeTitle: '（二）当您的个人信息有变更可能会影响到您使用我们的服务时，您有权对您的信息进行补充、更正、删除。',
      },

      {
        threeTitle: '（三）如果您对本隐私政策修改的任何内容存有疑问，您有权联系我们并要求我们给出合理解释。',
      },

      {
        threeTitle: '（四）当您基于任何理由不再使用我们的服务时，您有权注销平台账户或者取消微信授权登陆，并删除您所有的信息。',
      },

      {
        threeTitle: '（五）因我们平台可能会接入第三方（服务供应商、关联公司、广告合作伙伴、应用开发者等），对该第三方在我们平台发布的所有信息，不论你是否注销平台账户或者取消授权，您应始终保密，未经我们或者第三方授权，不得进行转载、抄袭或者以其他方式复制。否则，我们以及第三方平台有权依法追究您的法律责任。',
      },

    ],
  },

  {
    subTitle: '六、如何与我们取得来联系',
    subHeaderText: '当您对本政策有任何疑问，可以通过诸葛万年历界面的客服与我们联系或者留言。我们将尽快审核所涉问题，并在验证您的用户身份后的即时予以回复。',
  },

  {
    subTitle: '七、法律适用及争议解决',
    subHeaderText: '本隐私政策的订立、执行、解释及争议的解决均应适用中华人民共和国法律。',
    text: [
      {
        threeTitle: '因本隐私政策引起的或与本隐私政策有关的任何争议，各方应友好协商解决；协商不成的，任何一方均可将有关争议提交至本协议订立地上海市浦东新区有管辖权的人民法院处理。',
      },
    ],
  },
  {
    subTitle: '八、联系方式',
    text: [
      {
        threeTitle: '公司名称：海南蜗牛信息科技有限公司',
      }, {
        threeTitle: '注册地址：海南省澄迈县高新技术产业示范区海南生态软件园A17幢一层4001',
      }, {
        threeTitle: '办公地址：上海市浦东新区申江路 5005 弄星创科技1号楼9楼',
      }, {
        threeTitle: '联系邮箱：wannianli@xiaoniuhy.com',
      }, {
        threeTitle: '信息保护负责人联系电话：15221335681',
      },
    ],
  },
  ],
};
